module.exports = __webpack_public_path__ + "img/logo.717200b2.png";